import { render, staticRenderFns } from "./CustomBaseDataTable.vue?vue&type=template&id=0959dd94"
import script from "./CustomBaseDataTable.vue?vue&type=script&lang=js"
export * from "./CustomBaseDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports